<script setup lang="ts">
defineProps<{
  variant?: MenuContentProps["variant"];
}>();

function handleContextMenu(event: Event) {
  // prevent default browser context menu from opening
  event.preventDefault();
  event.stopPropagation();
}
</script>

<script lang="ts">
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export type MenuContentProps = VariantProps<typeof menuContent>;

const menuContent = cva([
  "relative rounded-md border border-slate-200/50 bg-white p-1 outline-hidden drop-shadow-md dark:border-zinc-600 dark:bg-slate-900 dark:text-slate-200",
], {
  variants: {
    variant: {
      grid: "grid grid-cols-[auto_auto_1fr_auto]",
      column: "flex flex-col",
    },
  },
  defaultVariants: {
    variant: "grid",
  },
});
</script>

<template>
  <div
    :class="menuContent({ variant })"
    @contextmenu="handleContextMenu"
  >
    <slot />
  </div>
</template>
